import React from 'react';
import { Button, Tooltip } from 'antd';
import { UndoOutlined, RedoOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';
import { mapToolbarStyles } from '../styles/mapToolbar';

interface MapToolbarProps {
  canUndo: boolean;
  canRedo: boolean;
  hasSelectedMarker: boolean;
  onUndo: () => void;
  onRedo: () => void;
  onDelete: () => void;
  isMobile?: boolean;
}

const ToolbarButton: React.FC<{
  icon: React.ReactNode;
  title: string;
  disabled: boolean;
  onClick: () => void;
  isActive?: boolean;
  isMobile?: boolean;
  testId: string;
}> = ({ icon, title, disabled, onClick, isActive = false, isMobile = false, testId }) => (
  <Tooltip title={title} placement="left">
    <Button
      type="text"
      icon={icon}
      disabled={disabled}
      onClick={onClick}
      className={cx(
        mapToolbarStyles.button,
        isMobile && mapToolbarStyles.buttonMobile,
        isActive && mapToolbarStyles.deleteButtonActive
      )}
      data-testid={testId}
    />
  </Tooltip>
);

export const MapToolbar: React.FC<MapToolbarProps> = ({
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  isMobile = false,
}) => {
  const containerClass = isMobile ? mapToolbarStyles.containerMobile : mapToolbarStyles.container;

  return (
    <div className={containerClass}>
      <ToolbarButton
        icon={<UndoOutlined className={mapToolbarStyles.icon} />}
        title="Undo (Ctrl+Z)"
        disabled={!canUndo}
        onClick={onUndo}
        isMobile={isMobile}
        testId="undo-button"
      />

      <ToolbarButton
        icon={<RedoOutlined className={mapToolbarStyles.icon} />}
        title="Redo (Ctrl+Y)"
        disabled={!canRedo}
        onClick={onRedo}
        isMobile={isMobile}
        testId="redo-button"
      />
    </div>
  );
};
